import { autoinject } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';

@autoinject()
export class ElliDataServiceMock {

    constructor(private readonly api: Api) { }

    public async getMemberData(memberId: string) {
        // INFO [Matt] This should be a get, but we don't allow that, so we 
        //  POST, and POSTs require bodies, so we pass an empty one.
        const action = this.api.action('Elli.Profile', `cd/members/${memberId}`, {});
        return await this.api.post(action);
    }
}
